import {
  Button,
  Divider,
  IconButton,
  Stack,
  createStyles,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import React, { useEffect, useState } from "react";
import { black } from "../../utils/StyleHelpers";
import { useContentStore } from "../../stores/contentStore";
import { locale } from "../../utils/LocaleManager";
import DriveFileMoveOutlinedIcon from "@mui/icons-material/DriveFileMoveOutlined";
import { useFolderStore } from "../../stores/folderStore";
import { useRolePermissionsStore } from "../../stores/rolePermissionsStore";

const buttonStyle = createStyles({
  color: black,
  textTransform: "none",
});

const FolderContextMenu = (props: any) => {
  const selectedFolders = useContentStore(
    (state: any) => state.selectedFolders,
  );
  const setSelectedFolders = useContentStore(
    (state: any) => state.setSelectedFolders,
  );
  const setIsShowDelete = useFolderStore((state: any) => state.setIsShowDelete);
  const rolePermissions = useRolePermissionsStore(
    (state: any) => state.rolePermissions,
  );
  const [isMultiple, setIsMultiple] = useState(false);

  useEffect(() => {
    setIsMultiple(selectedFolders.length > 1);
  }, [selectedFolders]);

  return (
    <Stack
      direction="row"
      divider={<Divider orientation="vertical" flexItem />}
      style={{
        background: "#F0F4F8",
        borderRadius: "0.5rem",
        padding: "0.25rem",
        gap: "2.5rem",
        alignItems: "center",
        marginBottom: "2.5rem",
        marginTop: "1rem",
        visibility: props?.isShow || props?.isShowPlayer ? "visible" : "hidden",
      }}
      justifyContent={props?.isShowPlayer ? "center" : ""}
    >
      <Stack direction="row" spacing={3}>
        <Stack direction="row">
          <IconButton aria-label="clear" onClick={() => setSelectedFolders([])}>
            <ClearIcon />
          </IconButton>
          <Button variant="text" disabled={true} style={buttonStyle}>
            {`${selectedFolders.length} ${locale.control_selected}`}
          </Button>
        </Stack>
        {!isMultiple && rolePermissions?.folder?.rename && (
          <Button
            variant="text"
            style={buttonStyle}
            startIcon={<DriveFileRenameOutlineIcon fontSize="small" />}
            onClick={props.onRename}
          >
            {locale.control_rename}
          </Button>
        )}
      </Stack>
      {!isMultiple && rolePermissions?.folder?.move && (
        <Stack direction="row" spacing={2}>
          <Button
            variant="text"
            style={buttonStyle}
            startIcon={<DriveFileMoveOutlinedIcon fontSize="small" />}
            onClick={props.onMove}
          >
            {locale.control_move}
          </Button>
        </Stack>
      )}
      {rolePermissions?.folder?.delete && (
        <Stack direction="row" spacing={2}>
          <Button
            variant="text"
            style={buttonStyle}
            startIcon={<DeleteOutlineOutlinedIcon fontSize="small" />}
            onClick={() => setIsShowDelete(true)}
          >
            {locale.control_delete}
          </Button>
        </Stack>
      )}
    </Stack>
  );
};

export default FolderContextMenu;
